import React, { useEffect, useMemo, useState } from 'react';

import { Chip, ChipList } from '@/components/shared/Chip';
import { Legend, LegendItem } from '@/components/shared/Legend';
import { LineChart } from '@/components/shared/LineChart';
import { ModalSectionCard } from '@/components/shared/ModalSectionCard';
import { ModalSectionSecondaryText } from '@/components/shared/ModalSectionSecondaryText';
import { ModalSectionTitle } from '@/components/shared/ModalSectionTitle';
import {
	getSongThemeColor,
	SongThemeChip,
} from '@/components/shared/SongThemeChip';
import { StreamChart } from '@/components/shared/StreamChart';
import { TeamSongThumbs } from '@/components/TeamSongThumbs';
import { GOSPEL_TAGS } from '@/config/constants';
import { classNames } from '@/helpers/classNames';
import { useTeamSongs } from '@/providers/TeamSongsProvider';

import ExampleChartLabel from '../ExampleChartLabel/ExampleChartLabel';
import { demoLineData } from './demoLineData';
import styles from './GospelFlow.module.scss';

const GospelFlow: React.FC<{
	teamSongIds: string[];
	className?: string;
}> = ({ teamSongIds, className }) => {
	const { findTeamSongsById } = useTeamSongs();
	const setlistTeamSongs = findTeamSongsById(teamSongIds);

	const tags = setlistTeamSongs.map((ts) => ts?.gospelTags);

	const flow = useMemo(() => {
		return tags.reduce<{ [key: string]: number }[]>((acc, t, i) => {
			// const matchValue = t ? 3 / t.length : 0;
			const matchValue = t ? 1 : 0;
			return [
				...acc,
				{
					[GOSPEL_TAGS[0].label]:
						t && t.includes(GOSPEL_TAGS[0].label) ? matchValue : 0,
					[GOSPEL_TAGS[1].label]:
						t && t.includes(GOSPEL_TAGS[1].label) ? matchValue : 0,
					[GOSPEL_TAGS[2].label]:
						t && t.includes(GOSPEL_TAGS[2].label) ? matchValue : 0,
				},
			];
		}, []);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tags.join()]);

	console.log({
		tags,
		flow,
	});

	return (
		<div className={styles['root']}>
			<ModalSectionCard paddingSize="lg" className={className}>
				<ModalSectionTitle>Gospel story</ModalSectionTitle>
				{teamSongIds.length > 1 ? (
					<>
						<Legend>
							<LegendItem
								label={GOSPEL_TAGS[0].capitalisedLabel}
								className={
									getSongThemeColor(
										GOSPEL_TAGS[0].capitalisedLabel,
									).className
								}
							/>
							<LegendItem
								label={GOSPEL_TAGS[1].capitalisedLabel}
								className={
									getSongThemeColor(
										GOSPEL_TAGS[1].capitalisedLabel,
									).className
								}
							/>
							<LegendItem
								label={GOSPEL_TAGS[2].capitalisedLabel}
								className={
									getSongThemeColor(
										GOSPEL_TAGS[2].capitalisedLabel,
									).className
								}
							/>
						</Legend>
						<StreamChart
							wrapperClassName={classNames([
								styles['line-chart'],
								'mt-sm',
							])}
							data={flow}
							keys={GOSPEL_TAGS.map((t) => t.label)}
						/>
						<TeamSongThumbs teamSongIds={teamSongIds} />
					</>
				) : (
					<>
						<ModalSectionSecondaryText className="mb-xl">
							Add more songs to see the gospel story flow of your
							setlist
						</ModalSectionSecondaryText>
						<div className={styles['wrapper']}>
							<StreamChart
								wrapperClassName={classNames([
									styles['line-chart'],
								])}
								data={demoLineData}
								keys={GOSPEL_TAGS.map((t) => t.label)}
							/>
							<ExampleChartLabel />
						</div>
					</>
				)}
			</ModalSectionCard>
		</div>
	);
};

export default GospelFlow;
